import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  handleError: any;
  headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  constructor(private http: HttpClient) {

  }

  getNotificationsForTopBar() {
    return this.http.get<any>(environment.API_URL + '/api/notifications?query[isEmail]=false&pageSize=7&sort=id:DESC');
  }
  getNotificationsForPage(pageSize: number, page: number, field: string) {

    return this.http.get<any>(environment.API_URL + `/api/notifications?query[isEmail]=false&pageSize=${pageSize}&page=${page}&sort=id:DESC&search=${field}&searchFields=message`);
  }
  getNotificationsForPageNotRead(pageSize: number, page: number, field: string) {
    return this.http.get<any>(environment.API_URL + `/api/notifications?query[isEmail]=false&pageSize=${pageSize}&page=${page}&sort=id:DESC&query[read]=false&search=${field}&searchFields=message`);
  }
  getNotification(notificationId: number) {
    return this.http.get<any>(environment.API_URL + `/api/notifications/${notificationId}`);
  }

  updateNotification(id: number) {
    return this.http.patch<any>(environment.API_URL + `/api/notifications/${id}/read`, {}, { headers: this.headers });
  }

  tree() {
    return this.http.get<any>(environment.API_URL + `/api/notifications/tree`);
  }

  realoadNotifications: Subject<any> = new Subject<any>()
}
